export default {
  goToPlatform: 'Go to platform'
}
